import { NodeWithMultipleHandles } from '../NodeWithMultipleHandles';

export function InternetNode(props) {
    return <NodeWithMultipleHandles {...props} nodeType="internet" />;
}
